import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import React from 'react';
import {i18n2} from '../../i18n/i18n';
import {useAddSpac, useDeleteSpac, useLoadSpac, useUpdateSpac} from '../hooks';
import {SpacSchema} from '../model/Spac';
import IntegritySpacGrid from './IntegritySpacGrid';
import {LookupProps} from 'components/grid-dx/MasterGrid';

export const lookupBuilding = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('Planta Alberti')},
      {id: 1, name: i18n2._('Planta Santa Cruz')},
      {id: 2, name: i18n2._('Planta Pagola')},
      {id: 3, name: i18n2._('Planta Pilar')},
      {id: 4, name: i18n2._('Cochabamba')},
      {id: 5, name: i18n2._('Casa Central')},
    ],
    key: 'id',
  },
};

export const lookupStatus = {
  store: {
    type: 'array',
    data: [
      {id: 0, name: i18n2._('En Ejecucion')},
      {id: 1, name: i18n2._('Validado')},
      {id: 2, name: i18n2._('Revalidado')},
      {id: 3, name: i18n2._('Baja')},
      {id: 4, name: i18n2._('Calificado')},
    ],
    key: 'id',
  },
};

const SpacGrid = () => {
  const loadSpac = useLoadSpac();
  const addSpac = useAddSpac();
  const updateSpac = useUpdateSpac();
  const deleteSpac = useDeleteSpac();
  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      schema={SpacSchema()}
      dataSource={loadSpac}
      promiseAdd={addSpac}
      promiseEdit={updateSpac}
      promiseDelete={deleteSpac}
      id={['iD_Spac']}
      columnOptions={columnOptions}
      integrityGrid={IntegritySpacGrid}
      integrityId={['ID_Spac']}
      integrityName={'Spac'}
      exportName="SPAC-export">
      <Column
        caption={i18n2._('SPAC')}
        dataField="iD_Spac"
        defaultSortOrder={'asc'}
      />
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column caption={i18n2._('Estado')} dataField="status">
        <Lookup
          dataSource={lookupStatus}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column caption={i18n2._('GXP')} dataField="gxp" />
      <Column caption={i18n2._('Planta')} dataField="building">
        <Lookup
          dataSource={lookupBuilding}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column caption={i18n2._('BP Propietario')} dataField="bpOwner" />
      <Column caption={i18n2._('Observacion')} dataField="observation" />
      <Column
        caption={i18n2._('Categoria de hardware')}
        dataField="catSw"
        visible={false}
      />
      <Column
        caption={i18n2._('Colaborador responsable')}
        dataField="respUser"></Column>
      <Column caption={i18n2._('Dueño del sistema')} dataField="sysOwner" />
      <Column caption={i18n2._('Aseg.Calidad')} dataField="qaUnit" />
      <Column caption={i18n2._('Experto Materia')} dataField="smExpert" />
      <Column
        caption={i18n2._('Fecha inicial')}
        dataField="dateStIni"
        visible={false}
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.dateStIni)}
      />
      <Column
        caption={i18n2._('Fecha fin')}
        dataField="dateStFin"
        visible={false}
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.dateStFin)}
      />
      <Column
        caption={i18n2._('Fecha real de inicio')}
        dataField="dateRealIni"
        visible={false}
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.dateRealIni)}
      />
      <Column
        caption={i18n2._('Fecha real de Fin')}
        dataField="dateRealFin"
        visible={false}
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.dateRealFin)}
      />
      <Column
        caption={i18n2._('Fecha Reval')}
        dataField="dateReval"
        visible={false}
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.dateReval)}
      />
      <Column
        caption={i18n2._('Proveedor de sistemas')}
        dataField="sysSupplier"
      />
      <Column
        caption={i18n2._('Servicio de IT')}
        dataField="itService"
        visible={false}
      />
      <Column caption={i18n2._('HSE')} dataField="hse" visible={false} />
      <Column caption={i18n2._('Activo')} dataField="active" />
      <Column
        caption={i18n2._('Propietario')}
        dataField="owner"
        visible={false}
      />
      <Column
        caption={i18n2._('Administrador')}
        dataField="admIng"
        visible={false}
      />
      <Column
        caption={i18n2._('Fomulario XMLS')}
        dataField="formXls"
        visible={false}
      />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        visible={false}
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column
        caption={i18n2._('Actualizado por')}
        dataField="updatedBy"
        visible={false}
      />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

const columnOptions = [
  {
    column: 'iD_Spac',
    sizeMobile: 12,
    sizeDesktop: 12,
    required: true,
    allowEdit: false,
  },
  {
    column: 'name',
    sizeMobile: 12,
    sizeDesktop: 12,
    required: true,
  },
  {
    column: 'owner',
    sizeMobile: 12,
    sizeDesktop: 3,
  },
  {
    column: 'gxp',
    sizeMobile: 12,
    sizeDesktop: 3,
  },
  {
    column: 'observation',
    sizeMobile: 12,
    sizeDesktop: 6,
  },
  {
    column: 'catSw',
    required: true,
  },
  {
    column: 'catHw',
    required: true,
  },
  {
    selectType: 'enum',
    column: 'status',
    data: [
      {
        key: 0,
        value: i18n2._('En ejecución'),
      },
      {
        key: 1,
        value: i18n2._('Validado'),
      },
      {
        key: 2,
        value: i18n2._('ReValidado'),
      },
      {
        key: 3,
        value: i18n2._('Baja'),
      },
      {
        key: 4,
        value: i18n2._('Calificado'),
      },
    ],
  },
  {
    column: 'building',
    selectType: 'enum',
    sizeMobile: 12,
    sizeDesktop: 3,
    data: [
      {
        key: 0,
        value: i18n2._('Planta Alberti'),
      },
      {
        key: 1,
        value: i18n2._('Planta Santa Cruz'),
      },
      {
        key: 2,
        value: i18n2._('Planta Pagola'),
      },
      {
        key: 3,
        value: i18n2._('Planta Pilar'),
      },
      {
        key: 4,
        value: i18n2._('Cochabamba'),
      },
      {
        key: 5,
        value: i18n2._('Casa Central'),
      },
    ],
  },
];
export default SpacGrid;
